export function scrollToTopImmediately() {
  const root = document.documentElement;
  const previousScrollBehavior = root.style.scrollBehavior;

  root.style.scrollBehavior = 'auto';
  window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
  root.style.scrollBehavior = previousScrollBehavior;
}
